import { getPropsDataByModalSelect } from "../helpers/propsModalDetails";
import { handlersUpdateForm } from "../helpers/updateProjectDetails";

export class ModalServices {
    constructor({ modals }) {
        this.modals = modals;

        this.handleEdit = this.handleEdit.bind(this);
        this.setProps = this.setProps.bind(this);
    }

    async actionByUpdate({ isUpdatePage, extraValue = { nextModal: null } }) {
        const { nextModal } = extraValue

        if (!nextModal && isUpdatePage) {
            await this.getProject(this.project.clickupSpace);
            this.closeModal()
            return
        }

        await this.getProject(this.project.clickupSpace);
        await this.setProps(nextModal)
    }


    async handleEdit(typeForm, form, extraValue) {
        try {
            if (!handlersUpdateForm[typeForm]) {
                this.closeModal()
                return
            }

            const { name: nameUser, email } = this.auth;
            const { clickupSpace, dates: { start }, pauses, isProjectRed } = this.project

            const extraData = {
                idSpace: clickupSpace,
                start,
                pauses,
                nameUser,
                email,
                isProjectRed,
            }

            const isUpdatePage = await handlersUpdateForm[typeForm]({
                form,
                extraData
            });

            await this.actionByUpdate({ isUpdatePage, extraValue })
        } catch (error) {
            console.log('error', error);
        }
    }

    async getProps({ type, extraProps }) {
        const props = await getPropsDataByModalSelect({
            type,
            auth: this.auth,
            projectDetails: this.project,
        });

        return {
            ...props,
            ...extraProps,
            closeModalDetails: this.closeModal,
            closeModalAndRefresh: this.closeModalAndRefresh,
            editFormForProjectDetails: this.handleEdit,
            activeModalDetailsProject: this.setProps,
            updateProject: this.getProject,
            propsData: {
                projectDetails: this.project,
                auth: this.auth,
            },
        }
    }

    async setProps(type, extraProps = {}) {
        if (!this.modals[type]) {
            this.renderModal(null)
            return
        };

        const propsByModal = await this.getProps({ type, extraProps })
        const ModalComponent = this.modals[type]
        const ModalRender = <ModalComponent {...propsByModal} />

        this.renderModal(ModalRender)

    }

    addExtraData({ project, auth, getProjectDetails, closeModal, renderModal, closeModalAndRefresh }) {
        this.project = project
        this.auth = auth
        this.getProject = getProjectDetails
        this.closeModal = closeModal
        this.renderModal = renderModal
        this.closeModalAndRefresh = closeModalAndRefresh
    }
}
